import actions from 'state/constants';

const setInitialCookieConsentReducer = (state, action) => ({
  ...state,
  initialGroups: action.payload.initialGroups,
});

export const reducer = (state = {}, action) => {
  switch (action.type) {
    case actions.SET_INITIAL_COOKIE_CONSENT_GROUPS:
      return setInitialCookieConsentReducer(state, action);

    default:
      return state;
  }
};

export default reducer;
